<template>
  <div id="downplayers">
    <mt-header :title="this.$store.getters.WordsConfig.CellList.wjgl">
      <router-link to slot="left">
        <mt-button icon="back"
                   @click.native="$router.back(-1)">{{this.$store.getters.WordsConfig.User.back}}</mt-button>
      </router-link>
    </mt-header>
    <mt-cell :title="this.$store.getters.WordsConfig.DownPlayers.allplayers"
             :value="this.$store.getters.UserInfo.userCount"></mt-cell>
    <mt-field :label="this.$store.getters.WordsConfig.DownPlayers.playerId"
              :placeholder="this.$store.getters.WordsConfig.DownPlayers.plzInputPlayerId"
              v-model="gameId"></mt-field>
    <mt-field :label="this.$store.getters.WordsConfig.DownPlayers.gameAccount"
              :placeholder="this.$store.getters.WordsConfig.DownPlayers.plzInputAccount"
              v-model="nickName"></mt-field>
    <div style="width:100%;display:inline-flex;background:white">
      <el-date-picker style="margin:4px"
                      v-model="startDate"
                      type="date"
                      :picker-options="pickerOptions0"
                      :placeholder="this.$store.getters.WordsConfig.WorkRecord.startDate"></el-date-picker>
      <el-date-picker style="margin:4px"
                      v-model="endDate"
                      type="date"
                      :picker-options="pickerOptions0"
                      :placeholder="this.$store.getters.WordsConfig.WorkRecord.endDate"></el-date-picker>
      <mt-button class="wrBtn"
                 type="primary"
                 size="small"
                 @click="query"
                 :disabled="queryBtnDisable">{{queryStr}}</mt-button>
    </div>

    <div style="width:100%;display:inline-flex;background:white;padding:5px 0">
      <mt-button class="wrBtn"
                 type="primary"
                 size="small"
                 @click="date0Click"
                 :disabled="queryBtnDisable">{{date0}}</mt-button>
      <mt-button class="wrBtn"
                 type="primary"
                 size="small"
                 @click="date1Click"
                 :disabled="queryBtnDisable">{{date1}}</mt-button>
      <mt-button class="wrBtn"
                 type="primary"
                 size="small"
                 @click="date2Click"
                 :disabled="queryBtnDisable">{{date2}}</mt-button>
      <mt-button class="wrBtn"
                 type="primary"
                 size="small"
                 @click="date3Click"
                 :disabled="queryBtnDisable">{{date3}}</mt-button>
    </div>
    <div style="position: absolute;top: 300px;left: 0;right: 0;bottom: 26px;">
      <el-table :data="tableData"
                height="100%"
                :empty-text="this.$store.getters.WordsConfig.TBEmptyText">
        <el-table-column fixed
                         prop="gameId"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.gameId"
                         header-align="center"
                         align="center"
                         width="88"></el-table-column>
        <el-table-column prop="gameAccount"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.gameAccount"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="Profit"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.Profit"
                         width="120"
                         header-align="center"
                         align="center"  v-if="this.$store.getters.UserInfo.displayType === 0"></el-table-column>
        <el-table-column prop="RechargeScore"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.RechargeScore"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="WithdrawScore"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.WithdrawScore"
                         width="120"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="gameBindTime"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.gameBindTime"
                         width="160"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="lastLogin"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.lastLogin"
                         width="160"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="firstRechargeDate"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.firstRechargeDate"
                         width="160"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="firstRechargeScore"
                         sortable
                         :label="this.$store.getters.WordsConfig.DownPlayers.firstRechargeScore"
                         width="160"
                         header-align="center"
                         align="center"></el-table-column>
      </el-table>
      <el-pagination small
                     class="pagination"
                     background
                     :total="totalcount"
                     :page-size="25"
                     :current-page.sync="currentPage"
                     layout="prev, pager, next"
                     @current-change="getNextPage"></el-pagination>
    </div>
  </div>
</template>

<script>
  import { G_SubU } from "../../api/api";
  export default {
    data() {
      return {
        currentPage: 1,
        totalcount:0,
        tableData: [],
        gameId: "",
        nickName: "",
        queryBtnDisable: false,
        startDate: "",
        endDate: "",
        datetype:10000,
        queryStr: this.$store.getters.WordsConfig.WorkRecord.query,
        date0: this.$store.getters.WordsConfig.WorkRecord.yesterday,
        date1: this.$store.getters.WordsConfig.WorkRecord.today,
        date2: this.$store.getters.WordsConfig.WorkRecord.lastmonth,
        date3: this.$store.getters.WordsConfig.WorkRecord.thismonth,
        pickerOptions0: {
          disabledDate(time) {
            let curDate = new Date().getTime();
            let two = 60 * 24 * 3600 * 1000;
            let twoMonths = curDate - two;
            return time.getTime() > Date.now() || time.getTime() < twoMonths;
          }
        }
      };
    },
    created() {
      this.getData(0);
    },
    methods: {
      showDate(a) {
        console.log(this.$moment(a).format("YYYY-MM-DD"));
      },
      date0Click() {
        //昨天
        this.startDate = this.$moment(new Date())
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.endDate = this.$moment(new Date())
          .add(-1, "days")
          .format("YYYY-MM-DD");
        this.datetype = 1;
      
        this.query();
        this.currentPage = 1;
      },
      date1Click() {
        this.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
        this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
        this.datetype = 0;
      
        this.query();
        this.currentPage = 1;
      },
      date2Click() {
        //上月
        this.startDate = this.$moment(new Date())
          .add(-1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        this.endDate = this.$moment(new Date())
          .add(-1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        this.datetype = 3;
      
        this.query();
        this.currentPage = 1;
      },
      date3Click() {
        //本月
        this.startDate = this.$moment(new Date())
          .startOf("month")
          .format("YYYY-MM-DD");
        this.endDate = this.$moment(new Date())
          .endOf("month")
          .format("YYYY-MM-DD");
        this.datetype = 2;
        this.query();
        this.currentPage = 1;
      },
      query() {
        console.log("query");
        console.log(this.datetype);

        this.queryBtnDisable = true;
        this.tableData = [];
        let st = this.startDate == "" ? 0 : new Date(this.startDate).getTime();
        let et = this.endDate == "" ? 0 : new Date(this.endDate).getTime();
        this.getData(
          0,
          st,
          et,
          this.nickName.trim(),
          this.gameId.trim() == "" ? 0 : this.gameId.trim(),
          this.datetype

        );
      },
      getData(id, st = 0, et = 0, nickname = "", gameid = 0, datetype) {
        try {
      
          this.queryBtnDisable = true;
          G_SubU(id, 25, datetype, st, et, nickname, gameid, 0)
            .then(res => {
              console.log("G_SubU")
              console.log(res.data)
              for (const it of res.data) {
                let item = {
                  gid: it.id,
                  gameId: it.gameID,
                  gameAccount: it.accounts,
                  RechargeScore: it.rechargeScore,
                  WithdrawScore: it.withdrawScore,
                  Profit: it.totalProfit,
                  gameBindTime: it.bindDate,
                  lastLogin: it.lastLogonDate,
                  firstRechargeDate: it.firstRechargeDate,
                  firstRechargeScore: it.firstRechargeScore
                };
                this.tableData.push(item);
              }
              this.totalcount = res.data[0].totalCount;
              this.queryBtnDisable = false;
            })
            .catch(err => {
              this.queryBtnDisable = false;
            });

        } catch (error) {
          this.tableData = [];
          this.queryBtnDisable = false;
        }
      },
      getNextPage(currPage) {
        this.tableData = [];
        let st = this.startDate == "" ? 0 : new Date(this.startDate).getTime();
        let et = this.endDate == "" ? 0 : new Date(this.endDate).getTime();
        this.getData(
          currPage - 1,
          st,
          et,
          this.nickName.trim(),
          this.gameId.trim() == "" ? 0 : this.gameId.trim(),
          this.datetype

        );

      },
      

    }
  };
</script>

<style lang="scss" scoped>
  #downplayers {
    height: 100%;
    overflow: hidden;
  }

  .pagination {
    position: absolute;
    bottom: -26px;
    width: 100%;
    background: white;
    text-align: center;
  }

  .wrBtn {
    width: 25%;
    font-size: small;
    padding: 2px 0;
    margin: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cells/DownPlayers.vue